module Meevo.Plugins.EmmaAccountSettings {
    export class EmailMarketingRestrictedSettingsController {
        static $inject = [
            '$mdDialog',
            "$timeout",
            "meevo.components.common.DataService",
            "meevo.components.busy.BusyService",
            "meevo.components.modal.ModalService",
            "$translate"
        ];

        public account: Meevo.Model.EmailMarketingSettings;
        public identityService: Meevo.Components.Common.IIdentityService
        public updatedAccount: Meevo.Model.EmailMarketingSettings;
        public showAccountConfig: boolean = null;

        constructor(private $mdDialog: ng.material.IDialogService,
            protected $timeout: ng.ITimeoutService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: ng.translate.ITranslateService
        ) {
            console.log('restricted settings controller', this.account)
            this.updatedAccount = angular.copy(this.account);
            this.showAccountConfig = this.identityService.inCentralOfficeMode() && !this.identityService.current().isSingleLocation;
           
        }

        public close(): void {
            this.$mdDialog.cancel();
        }

        public ok(): void {
            this.$mdDialog.hide(this.updatedAccount);
        }

        isMSIUser(): boolean {
            return this.identityService.current().userTypeEnum === Model.UserTypeEnum.MSIUser;
        }

        showAccountId(): boolean {
            return (this.identityService.inCentralOfficeMode() && !this.updatedAccount.locationLevelSubaccount)
                || !this.identityService.inCentralOfficeMode()
        }

        showSyncOptions(): boolean {
            return this.identityService.current().isSingleLocation ||
                !(this.updatedAccount.locationLevelSubaccount && this.identityService.inCentralOfficeMode());
        }
        
    }

    angular.module('meevo.plugins.emmaAccountSettings')
        .controller('meevo.plugins.emmaAccountSettings.EmailMarketingRestrictedSettingsController', EmailMarketingRestrictedSettingsController);


}
